// Copyright © 2026 ApexRuntime Labs by Shashi (https://github.com/spshah). All rights reserved.

import api from '../../axios';

const paymentAPI = {
  // Payment Cards
  listCards: (params = {}) =>
    api.get('/api/budget/cards/', { params }),

  createCard: (data) =>
    api.post('/api/budget/cards/', data),

  detailCard: (id) =>
    api.get(`/api/budget/cards/${id}/`),

  updateCard: (id, data) =>
    api.patch(`/api/budget/cards/${id}/`, data),

  deleteCard: (id) =>
    api.delete(`/api/budget/cards/${id}/`),

  // Statements (nested under cards)
  getStatements: (cardId, params = {}) =>
    api.get(`/api/budget/cards/${cardId}/statements/`, { params }),

  createStatement: (cardId, data) =>
    api.post(`/api/budget/cards/${cardId}/statements/`, data),

  updateStatement: (cardId, statementId, data) =>
    api.patch(
      `/api/budget/cards/${cardId}/statements/${statementId}/`,
      data,
    ),

  // Payment Modes
  listModes: (params = {}) =>
    api.get('/api/budget/payment-modes/', { params }),

  createMode: (data) =>
    api.post('/api/budget/payment-modes/', data),

  detailMode: (id) =>
    api.get(`/api/budget/payment-modes/${id}/`),

  updateMode: (id, data) =>
    api.patch(`/api/budget/payment-modes/${id}/`, data),

  deleteMode: (id) =>
    api.delete(`/api/budget/payment-modes/${id}/`),
};

export default paymentAPI;
